<template>
    <MainContent title="Crear usuario">
        <template v-slot:header>
            <h3 class="card-title">Crear usuario</h3>
        </template>
        <template v-slot:content v-if="!loading">
            <FormComponent :taquillero="taquillero" :error="error" :regions="regions" @getZonas="getZonas"  @terminado="crearTaquillero" />
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormComponent from '@/components/backend/taquilleros/FormComponent';

    export default {
        props: ['id'],
        data() {
            return {
                taquillero: {},
                error: null,
                regions: [],
                loading: false
            }
        },
        computed: {
            place() {
                return this.$store.getters.getRecinto;
            }
        },
        methods: {
            crearTaquillero() {
                this.taquillero.filters = {};

                this.$store.dispatch(this.config.getVuexAlias('back.taquilleros.crear'), this.taquillero).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.taquilleros.index' });
                }).catch(error => {
                    console.log(error);
                    this.error = true;
                });
            },
            getZonas() {
                this.loading = true;
                const params = {
                    filters: {
                        place_id: this.place.id
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.regions = res.data.map(({ id, name }) => ({ id, name }));
                    this.loading = false;
                });
            },
        },
        components: {
            MainContent, FormComponent
        }
    }
</script>
